/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Head_MetaInputs */

const en_wb_management_head_meta = /** @type {(inputs: Wb_Management_Head_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft · Monday, 08:30`)
};

const lv_wb_management_head_meta = /** @type {(inputs: Wb_Management_Head_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnraksts · pirmdien, 08:30`)
};

/**
* | output |
* | --- |
* | "Draft · Monday, 08:30" |
*
* @param {Wb_Management_Head_MetaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_head_meta = /** @type {((inputs?: Wb_Management_Head_MetaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Head_MetaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_head_meta(inputs)
	return en_wb_management_head_meta(inputs)
});